import LabelField from './LabelField';
import FormErrorMessage from '../../Form/FormErrorMessage/FormErrorMessage';

import classes from './LabelFieldFormik.module.scss';

const LabelFieldFormik = ({ className, name, label, children, popover }) => {
  const containerClasses = [classes.container];
  if (className) {
    containerClasses.push(className);
  }

  return (
    <LabelField className={containerClasses.join(' ')} key={name} popover={popover} name={name} label={label}>
      {children}
      <FormErrorMessage name={name} />
    </LabelField>
  );
};

export default LabelFieldFormik;
